<template>
  <div class="section role-int">
    <div class="h-tt">
      <h2>角色介绍</h2>
      <!-- <a href="" class="more">更多</a> -->
    </div>
    <SwiperBox :tabs="list">
      <div
        v-for="(item, i) in list"
        :key="i"
        class="swiper-slide"
        @click="
          $xlaGamePush('home_role_introduce_module_click', {
            text: item.description
          })
        "
      >
        <img :src="item.img_url" />
        <div class="role-info">
          <ul>
            <li v-for="(val, key) in getExtra(item)" :key="key">
              <em>{{ key }}：</em>{{ val }}
            </li>
          </ul>
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </SwiperBox>
  </div>
</template>

<script>
import SwiperBox from '../common/SwiperBox'
export default {
  components: {
    SwiperBox
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      cur: 0,
      swiper: null,
      tabs: [{ title: '战士' }, { title: '法师' }, { title: '道士' }]
    }
  },
  mounted() {
    this.$xlaGamePush('home_role_introduce_module_show')
  },
  methods: {
    getExtra({ extra_json }) {
      try {
        return JSON.parse(extra_json)
      } catch (error) {
        return {}
      }
    }
  }
}
</script>
